import { useState, useRef, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { formatDate } from '../../services/util'
const colors = ['#FF5733', '#FFD700', '#00FF00', '#FF00FF', '#00FFFF', '#FF6347', '#FFD700', '#32CD32', '#DA70D6', '#87CEEB', '#FF4500', '#FF8C00', '#7CFC00', '#9400D3', '#00FF7F', '#FF1493', '#00BFFF', '#FFA07A', '#FFD700', '#00FF00', '#FF00FF', '#00FFFF', '#FF6347', '#FFD700', '#32CD32', '#DA70D6', '#87CEEB', '#FF4500', '#FF8C00'];


export function ProducerChat({ initialMessages, socket, videoId, token, isConnected, openPopup, user, isNew}) {
    const [messages, setMessages] = useState(initialMessages)
    const input = useRef()
    const { _id, name } = useSelector(state => state.user)
    const messagesRef = useRef()

    useEffect(() => {
        setTimeout(() => {
            if (messagesRef?.current?.scrollHeight)
                messagesRef.current.scrollTop = messagesRef.current.scrollHeight
        }, 500)
        if (socket) {
            socket.on('recieve-message', (msg) => {
                setMessages((prev) => [...prev, msg])
                setTimeout(() => {
                    messagesRef.current.scrollTop = messagesRef.current.scrollHeight
                }, 100)
            })
        }
        return () => {
            if (socket) socket.off('recieve-message')
        }
    }, [socket])

    const sendMessage = (ev) => {
        ev.preventDefault()
        if (!isConnected) return openPopup()
        const msg = {
            id: Date.now(),
            text: input.current.value,
            time: new Date(),
            from: name,
            fromId: _id,
            color: colors[(user.name.charCodeAt(0) + user.name.charCodeAt(1)) % colors.length]
        }
        socket.emit('send-message', { msg, videoId, token })
        input.current.value = ''
    }

    if (!socket) return null

    return <>
        <h3>צ'אט {isNew && <span className="yellow-text"> (חדש)</span>}</h3>
        <div className='chat'>
            <div className='messages' ref={messagesRef}>
                {messages.length ? messages.map((message) => <div className={'message-wrapper ' + (message.fromId === _id ? 'left' : 'right')} key={message.id} >
                    <div className='message' >
                        <p style={{ color: message.color, fontWeight: '700' }}>{message.from}</p>
                        <p> {message.text}</p>
                        <p className='time'>{formatDate(message.time)}</p>
                    </div>
                </div>) : <p>אין הודעות כרגע</p>}
            </div>
            <form className='input-wrapper' onSubmit={sendMessage}>
                <input ref={input} />
                <button type='submit'>
                    <span className='material-symbols-outlined mirror'>send</span>
                </button>
            </form>
        </div>
    </>
}